import { ProjectRecord, UserType } from "@/types";

export const allowEditProject = (
  role: UserType["role"] | null,
  status: ProjectRecord["enrolmentStatus"],
) => {
  switch (role) {
    case "oem":
      return false;
    case "administrator":
      return true;
    case "contractor":
      return status !== "rejected";
    default:
      return false;
  }
};
